import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { environment } from '@env';
import { LoaderService } from '@services/loader.service';
import { PagesService } from '@services/pages.service';
import { ChartDataset, ChartOptions, ChartType, TooltipItem } from 'chart.js';
import moment from 'moment';
// import { Color, Label } from 'ng2-charts';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'wsb-landing-links',
  templateUrl: './landing-links.component.html',
  styleUrls: ['./landing-links.component.scss'],
  standalone: false
})
export class LandingLinksComponent implements OnInit {
  @Input() periods: any;
  @Input() loadingPeriod: any;
  @Input() page: any;

  public readonly today = new Date();

  pageClickByDay;
  dateFrom: UntypedFormControl = new UntypedFormControl();
  dateTo: UntypedFormControl = new UntypedFormControl();
  period: UntypedFormControl = new UntypedFormControl();

  // public lineChartPerDayLegend = false;
  public lineChartPerDayType: ChartType = 'line';
  public lineChartPerDayOptions?: ChartOptions;
  public lineChartPerDayData: ChartDataset[] = [];
  public lineChartPerDayLabels: string[] = [];

  constructor(private pagesService: PagesService, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.updateAxes();
    this.onPageChange();
    this.onSelectionChange(this.loadingPeriod);
  }

  getPageById(idPage) {
    if (!idPage) {
      return;
    }
    this.pagesService.getPageById(idPage).subscribe(page => {
      this.page = page;
    });
  }

  getClickByDay(idPage, dateFrom, dateTo) {
    if (!idPage) {
      return;
    }
    this.loaderService.show();
    this.pagesService
      .getPagesStatsGetClicksByDay(idPage, this.fixDate(dateFrom), this.fixDate(dateTo))
      .pipe(finalize(() => this.loaderService.hide()))
      .subscribe(clickByDay => {
        this.pageClickByDay = clickByDay;
        this.lineChartPerDayData = [];
        clickByDay.forEach(link => {
          this.lineChartPerDayData.push({
            data: link.statistics.values,
            label: link.resource ? link.resource : '',
            backgroundColor: 'rgba(0, 0, 0 , 0.0)',
            borderColor: [
              environment.chartsColorPalette[0],
              environment.chartsColorPalette[1],
              environment.chartsColorPalette[2],
              environment.chartsColorPalette[3],
              environment.chartsColorPalette[4]
            ],
            pointBorderColor: [
              environment.chartsColorPalette[0],
              environment.chartsColorPalette[1],
              environment.chartsColorPalette[2],
              environment.chartsColorPalette[3],
              environment.chartsColorPalette[4]
            ],
            pointHoverBorderColor: 'rgba(148,159,177,0.8)'
          });
        });
        this.lineChartPerDayLabels = [...clickByDay[0].statistics.labels];
      });
  }

  search() {
    this.getClickByDay(this.page?.idPage, this.dateFrom.value, this.dateTo.value);
  }

  onPageChange() {
    this.pagesService.selectionChange.subscribe(page => {
      this.getPageById(page?.idPage);
    });
  }

  onSelectionChange(period) {
    this.dateFrom.setValue(this.setDateForFc(period.dateFrom));
    this.dateTo.setValue(this.setDateForFc(period.dateTo));
    this.getClickByDay(this.page?.idPage, period.dateFrom, period.dateTo);
  }

  setDateForFc(date) {
    return new Date(
      moment(date)
        .format('ddd MMM DD YYYY HH:mm:ss')
        .toString()
    );
  }

  fixDate(date) {
    return (
      moment(date)
        .format('YYYY-MM-DDTHH:mm:ss')
        .toString() + 'Z'
    );
  }

  private updateAxes(): void {
    this.lineChartPerDayOptions = {
      elements: {
        line: {
          tension: 0
        }
      },
      plugins: {
        tooltip: {
          mode: 'index',
          callbacks: {
            title(context: TooltipItem<ChartType>[]): string | string[] {
              return `${context[0].label} - ${context[0].raw}`;
            },
            label(context: TooltipItem<ChartType>): string | string[] {
              return undefined;
            }
          }
        },
        legend: {
          position: 'bottom'
        }
      },
      responsive: true,
      scales: {
        y: {
          beginAtZero: true,
          ticks: { stepSize: 1, maxTicksLimit: 10 }
        },
        x: {
          grid: { color: 'rgba(255,0,0,0.0)' }
        }
      }
    };
  }
}
